export const isOversizedImage = (file: File) => {
  const sizeLimit = 1024 * 1024 * 5;
  return file.size > sizeLimit;
};
